import { useEffect, useState } from "react";
import Footer from "../Components/Footer";
import { Header } from "../Components/Header";
import ReactLoading from "react-loading";
import axios from "axios";
import { useSelector } from "react-redux";
import { profileSwitch, store } from "../Store/Store";

export const TransitionStatus = () => {
  store.dispatch(profileSwitch(false));
  const [load, setLoad] = useState(false);
  const [status, setStatus] = useState();
  const [addres, setAddres] = useState(
    localStorage.getItem("transactionAddres")
  );

  const sumStatus = useSelector((state) => state.currentTransitionSum);

  store.dispatch(profileSwitch(false));

  const themeStatus = useSelector((state) => state.currentTheme);

  useEffect(() => {
    async function fetchAddres() {
      let addres = "";
      setLoad(true);
      await axios
        .get(`https://point1.bot-n.ru/address_bitcoin/${sumStatus.sum}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        })
        .then((response) => {
          localStorage.setItem("transactionAddres", response.data.address);
          addres = response.data.rand_name;
        });

      const connectInterval = setInterval(getStatus, 15000);

      async function getStatus() {
        await axios
          .get(`https://point1.bot-n.ru/address_bitcoin_status/${addres}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          })
          .then((response) => {
            setAddres(response.data.wal_address);

            if (response.data.status == "pending") {
              setStatus("Ожидание адреса");
            } else if (response.data.status == "transaction_waiting") {
              setLoad(false);
              setStatus("Ожидание транзакции");
            } else if (response.data.status == "done") {
              if (
                localStorage.getItem("accountStatus") == null &&
                JSON.parse(localStorage.getItem("uniq")) != false
              ) {
                alert("Пароль аккаунта отправлен на почту");
              }
              setStatus("Готово");
              clearInterval(connectInterval);
            }
          });
      }
    }
    fetchAddres();
  }, []);

  return (
    <div>
      <div className={themeStatus == "dark" ? "mainBox" : "mainBoxLight"}>
        <div className="light x1"></div>
        <div className="light x3"></div>
        <div className="light x5"></div>
        <div className="light x7"></div>
        <div className="light x9"></div>
        <Header></Header>
        <div className="transitionStatusBox">
          <div className="transitionTitle">
            Для осуществления операции отправьте средства на этот адрес:
          </div>
          <div className="transitionAddres">
            {load ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "10px",
                  minWidth: "100%",
                }}
              >
                <ReactLoading
                  type="spinningBubbles"
                  color="white"
                  height={"50px"}
                  width={"50px"}
                />
              </div>
            ) : (
              <div>{addres == null ? "Ожидание номера кошелька" : addres}</div>
            )}
          </div>
          <div className="transitionAmount">
            Вы собираетесь перевести: {localStorage.getItem("coinAmount")}{" "}
            {localStorage.getItem("transitionCoin")}
          </div>
          <div className="transitionStatus">
            Статус транзакции: {status || "Ожидание транзакции"}
          </div>
        </div>
      </div>{" "}
      <Footer></Footer>
    </div>
  );
};
